var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pane",class:_vm.classes,style:(_vm.style)},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{key:_vm.transitionKey,staticClass:"pane-inner",class:_vm.innerClasses},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }